import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom, Observable } from "rxjs";
import { ARestClient } from "@zaeper/communication-lib";
import {
  IConfirmSetupResponse,
  IGenerateSecretResponse,
  IRegenerateRecoveryCodesResponse,
  ITwoFactorRestClient,
  ITwoFactorStatus
} from "@zaeper/angular-2fa-lib";
import { HostUtil } from "../../utils/host-util";

@Injectable()
export class TwoFactorRestClient extends ARestClient implements ITwoFactorRestClient {
  constructor( private readonly _httpClient: HttpClient ) {
    super();
  }

  public getStatus(): Promise<ITwoFactorStatus> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getAuthenticationApiEndpointUrl(), "v1/two-factor/status" );
    return firstValueFrom( this._httpClient.get( endpointUrl, { withCredentials: true } ) as Observable<ITwoFactorStatus> );
  }

  public generateSecret(): Promise<IGenerateSecretResponse> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getAuthenticationApiEndpointUrl(), "v1/two-factor/generate-secret" );
    return firstValueFrom( this._httpClient.post( endpointUrl, {}, { withCredentials: true } ) as Observable<IGenerateSecretResponse> );
  }

  public confirmSetup( totpCode: string ): Promise<IConfirmSetupResponse> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getAuthenticationApiEndpointUrl(), "v1/two-factor/confirm-setup" );
    return firstValueFrom( this._httpClient.post( endpointUrl, { totpCode }, { withCredentials: true } ) as Observable<IConfirmSetupResponse> );
  }

  public async disable( verificationCode: string ): Promise<void> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getAuthenticationApiEndpointUrl(), "v1/two-factor/disable" );
    await firstValueFrom( this._httpClient.post( endpointUrl, { verificationCode }, { withCredentials: true } ) );
  }

  public regenerateRecoveryCodes( totpCode: string ): Promise<IRegenerateRecoveryCodesResponse> {
    const endpointUrl: string = super.getEndpointUrl( HostUtil.getAuthenticationApiEndpointUrl(), "v1/two-factor/regenerate-recovery-codes" );
    return firstValueFrom( this._httpClient.post( endpointUrl, { totpCode }, { withCredentials: true } ) as Observable<IRegenerateRecoveryCodesResponse> );
  }
}
